import { useCallback, useState } from 'react'

import useImageAssetUpload from 'Pods/ThreeDStudio/Hooks/useImageAssetUpload'
import captureViewerImage from 'Pods/ThreeDStudio/Services/captureViewerImage/captureViewerImage'

/**
 * Captures the viewer and uploads it as the Render run's input image.
 *
 * @returns {{ captureRenderInput: (viewer: Object|null) => Promise<number|null>, isCapturing: boolean }}
 *   captureRenderInput resolves with the uploaded asset id, or null when the viewer could
 *   not be captured or the upload failed.
 */
export default function useRenderInputImage() {
  const uploadImageAsset = useImageAssetUpload()
  const [isCapturing, setIsCapturing] = useState(false)

  const captureRenderInput = useCallback(async (viewer) => {
    setIsCapturing(true)

    try {
      const file = await captureViewerImage(viewer)

      return file ? await uploadImageAsset(file) : null
    } catch {
      return null
    } finally {
      setIsCapturing(false)
    }
  }, [uploadImageAsset])

  return { captureRenderInput, isCapturing }
}
